import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: 'db-tab-subhead',
    templateUrl: './tab-subhead.component.html',
    styleUrls: ['./tab-subhead.component.scss'],
    standalone: false
})
export class TabSubHeadComponent {

  @Input() subTabId: string;
  @Input() activeSubTabId: string;
  @Output() onTabSubHeadClick: EventEmitter<{tabId: string}>;

  constructor() {
    this.onTabSubHeadClick = new EventEmitter<{tabId: string}>();
  }

  public onClick(): void {
    this.onTabSubHeadClick.emit({
      tabId: this.subTabId
    });
  }

}
